export default __webpack_public_path__ + "static/media/lockfree_icon.2493775f.svg";